import React from 'react';
import ReactDOM from 'react-dom/client';

//normalize css between browsers and reset to css initial values before applying bootstrap and custom styles
import './normalize.css';

// Bootstrap CSS now imported via sass in
//import 'bootstrap/dist/css/bootstrap.min.scss';
// Bootstrap Bundle JS
import 'bootstrap/dist/js/bootstrap.bundle.min';

// Load custom css after bootstrap so we can overwrite bootstrap if needed
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
